import { ENTITY_API_URL } from "../environment";
import { initAxiosFor } from "../security/axiosUtils";
import { IComment } from "./types";

export function useCommentService() {
  const axiosInstance = initAxiosFor(ENTITY_API_URL);
  const baseUrl = "/api/comments";

  return {
    getComments: async (referenceId: string, referenceType: string = "Site"): Promise<IComment[]> => {
      const response = await axiosInstance.get(`${baseUrl}?referenceId=${referenceId}&referenceType=${referenceType}`);
      return response?.data ?? [];
    },

    postComment: async (comment: Partial<IComment>): Promise<IComment> => {
      const response = await axiosInstance.post(baseUrl, comment);
      return response?.data;
    },

    putComment: async (id: string, comment: IComment): Promise<IComment> => {
      const response = await axiosInstance.put(`${baseUrl}/${id}`, comment);
      return response?.data;
    },

    deleteComment: async (id: string): Promise<void> => {
      await axiosInstance.delete(`${baseUrl}/${id}`);
    },
  };
}
